import AlinmaBankToSystemRoutes from './alinmaBankToSystem.js';
import AnbBankToSystemRoutes from './anbBankToSystem.js';
import RiyadhBankToSystemRoutes from './riyadhBankToSystem.js';
import SystemToAlinmaBankRoutes from './systemToAlinmaBank.js';
import SystemToAnbBankRoutes from './systemToAnbBank.js';
import SystemToRiyadhBankRoutes from './systemToRiyadhBank.js';

export default [
  ...AlinmaBankToSystemRoutes,
  ...RiyadhBankToSystemRoutes,
  ...SystemToAlinmaBankRoutes,
  ...SystemToRiyadhBankRoutes,
  ...AnbBankToSystemRoutes,
  ...SystemToAnbBankRoutes,
];
